export const PriceSpace = (price: string): string => {
  if (!price) {
    return "";
  }

  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) {
    return "";
  }

  const formattedPrice = numericPrice
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    .replace(/\.00$/, "");

  return `${formattedPrice} ₽`;
};
